import { useParams } from "react-router";
import "./ItemPage.css";
import { deleteItem, fetchItem, ListItem, saveItem } from "../api/item";
import { useEffect, useState } from "react";
import { Button, Dialog, TextField } from "@mui/material";
import StarRating from "../components/StarRating";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function ItemPage() {
  const { id } = useParams<{ id: string }>();
  const idnum = parseInt(id ?? "");
  const [item, setItem] = useState<ListItem | null>(null);
  const [confirmationOpen, setConfirmationOpen] = useState<boolean>(false);

  useEffect(() => {
    async function update() {
      let it = await fetchItem(idnum);
      setItem(it);
    }
    update();
  }, [idnum]);

  async function onSave() {
    if (!item) return;
    await saveItem(item);
    //go back
    window.history.back();
  }
  async function onDelete() {
    if (!item) return;
    await deleteItem(item.itemid);
    window.history.back();
  }

  const handleFieldChange = (field: keyof ListItem, value: any) => {
    setItem((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  if (!item) {
    return <div className="ItemPage-loading">Loading...</div>;
  }

  return (
    <div className="ItemPage">
      <h1>{item.name}</h1>
      <div className="ItemDetails">
        <TextField
          label="Name"
          value={item.name}
          onChange={(e) => handleFieldChange("name", e.target.value)}
          fullWidth
        />
        <StarRating
          rating={item.rating}
          onChange={(newRating) => handleFieldChange("rating", newRating)}
        />
        <TextField
          label="Notes"
          value={item.notes ?? ""}
          onChange={(e) => handleFieldChange("notes", e.target.value)}
          multiline
          rows={4}
          fullWidth
        />
        <TextField
          label="Tags"
          value={item.tags ?? ""}
          onChange={(e) => handleFieldChange("tags", e.target.value)}
          fullWidth
        />
        <TextField
          label="Pictures"
          value={item.pictures ?? ""}
          onChange={(e) => handleFieldChange("pictures", e.target.value)}
          fullWidth
        />
        <TextField
          label="Location"
          color="secondary"
          value={item.location ?? ""}
          onChange={(e) => handleFieldChange("location", e.target.value)}
          fullWidth
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Date Visited"
            value={item.datevisited ? dayjs(item.datevisited) : null}
            onChange={(newdate) => {
              handleFieldChange("datevisited", newdate);
            }}
          />
        </LocalizationProvider>
      </div>
      <div className="ItemActions">
        <Button variant="contained" color="primary" onClick={onSave}>
          Save
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => setConfirmationOpen(true)}
        >
          Delete
        </Button>
      </div>
      <Dialog
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
      >
        <div className="ItemPage-dialog">
          <h2>Are you sure you want to delete this item?</h2>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant="outlined"
              onClick={() => setConfirmationOpen(false)}
            >
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
